import React from 'react'

function PlusBlue(props) {
    return (
        <svg style={{marginBottom: props.marginBottom || "2px", marginRight:'4px'}} xmlns="http://www.w3.org/2000/svg" width="10.188" height="10.188" viewBox="0 0 10.188 10.188">
        <defs></defs>
        <g transform="translate(0.75 0.75)">
        <path class="a" fill="none" stroke={props.color||"#0072C6"} strokeLinecap="round" strokeWidth="1.5px" d="M-2226.408,19990v8.688" transform="translate(2230.751 -19990)"/>
        <path class="a" fill="none" stroke={props.color||"#0072C6"} strokeLinecap="round" strokeWidth="1.5px" d="M0,0V8.688" transform="translate(8.688 4.344) rotate(90)"/>
        </g>
        </svg>
    )
}

export default PlusBlue
